import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, PublicOnlyRoute } from "@/components/auth/RouteGuards";
import AppShell from "@/components/layout/AppShell";
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import CheckEmail from "@/pages/auth/CheckEmail";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import AuthConfirm from "@/pages/auth/AuthConfirm";
import Home from "@/pages/Home";
import ChatPage from "@/pages/ChatPage";
import ChatsPage from "@/pages/ChatsPage";
import PlanUsagePage from "@/pages/PlanUsagePage";
import SettingsPage from "@/pages/SettingsPage";
import PlannedPage from "@/pages/PlannedPage";
import FilesPage from "@/pages/FilesPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectPage from "@/pages/ProjectPage";
import CreateLayout from "@/pages/create/CreateLayout";
import ExplorePage from "@/pages/create/ExplorePage";
import ImageStudioPage from "@/pages/create/ImageStudioPage";
import VideoStudioPage from "@/pages/create/VideoStudioPage";
import AssetsPage from "@/pages/create/AssetsPage";
import PresetsPage from "@/pages/create/PresetsPage";
import InfluencerPage from "@/pages/create/InfluencerPage";
import AdsPage from "@/pages/create/AdsPage";
import ModelsPage from "@/pages/create/ModelsPage";
import VoicePage from "@/pages/VoicePage";

// Research (standalone page) and Tasks are outside the launch scope: their pages stay in the codebase but are not routed.
const PLANNED = [];

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TooltipProvider delayDuration={250}>
          <Routes>
            <Route element={<PublicOnlyRoute />}>
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/check-email" element={<CheckEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </Route>
            <Route path="/auth/confirm" element={<AuthConfirm />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route index element={<Home />} />
                <Route path="/chat/:conversationId?" element={<ChatPage />} />
                <Route path="/chats" element={<ChatsPage />} />
                <Route path="/plan" element={<PlanUsagePage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/files" element={<FilesPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/projects/:projectId" element={<ProjectPage />} />
                <Route path="/create" element={<CreateLayout />}>
                  <Route index element={<ExplorePage />} />
                  <Route path="image" element={<ImageStudioPage />} />
                  <Route path="video" element={<VideoStudioPage />} />
                  <Route path="assets" element={<AssetsPage />} />
                  <Route path="presets" element={<PresetsPage />} />
                  <Route path="influencer" element={<InfluencerPage />} />
                  <Route path="ads" element={<AdsPage />} />
                  <Route path="models" element={<ModelsPage />} />
                </Route>
                <Route path="/voice" element={<VoicePage />} />
                {PLANNED.map((key) => (
                  <Route key={key} path={`/${key}`} element={<PlannedPage sectionKey={key} />} />
                ))}
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster
            theme="dark"
            position="bottom-center"
            toastOptions={{ classNames: { toast: "!bg-ink-800 !border-white/10 !text-zinc-100 !rounded-xl" } }}
          />
        </TooltipProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
